import { render, staticRenderFns } from "./PutCompanyBlockchain.vue?vue&type=template&id=16101c2d"
import script from "./PutCompanyBlockchain.vue?vue&type=script&lang=js"
export * from "./PutCompanyBlockchain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports